import request from '@/utils/request'

// 作業予定一覧（作業日単位) 条件・コメント
export function getWeeklyCondition(data) {
  return request({
    url: `/api/workingPlanAndResultRc/getWeeklyCondition`,
    method: 'post',
    data,
  })
}

// 作業日程調整履歴
export function getworkAdjustResume(data) {
  return request({
    url: `/api/workingPlanAndResultRcHistory/${data}/list`,
    method: 'get',
  })
}

// 作業日程変更 検索
export function getworkScheduleChange(data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/${data}`,
    method: 'get',
  })
}

// 作業日詳細（日程追加） 発注詳細
export function getDetail(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/detail/${data}`,
    method: 'get',
    data,
  })
}

// 作業日詳細（日程追加） 作業日詳細取得（複数件）
export function getWorkPlanDateList(data) {
  return request({
    url: `/api/purchaseOrderDetailRc/workPlanDateList/${data}`,
    method: 'get',
    data,
  })
}
//作業日程変更 依頼取消
export function cancelRequest(workingPlanAndResultRcId, data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/cancelRequest/${workingPlanAndResultRcId}`,
    method: 'post',
    data,
  })
}
//作業日程変更 確認
export function changeConfirm(data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/changeConfirm`,
    method: 'post',
    data,
  })
}

//作業日程変更 更新
export function changeUpdate(data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/update`,
    method: 'post',
    data,
  })
}
//作業日程変更 変更依頼
export function changeRequest(data) {
  return request({
    url: `/api/workingPlanAndResultRc/edit/changeRequest`,
    method: 'post',
    data,
  })
}

//(協力会社側)作業予定一覧 登録
export function updateWorkPlanInput(data) {
  return request({
    url: `/api/workingPlanAndResultRc/updateWorkPlanInputList`,
    method: 'post',
    data,
  })
}

// 共通 建物・FM情報
export function queryBuildingInformation(query) {
  return request({
    url: `/api/workingPlanAndResultRc/queryBuildingInformation/${encodeURIComponent(
      query.buildingCd
    )}?sectionCd=${query.sectionCd}`,
    method: 'get',
    query,
  })
}

//点検仕様取得
export function getFoundSelfData(data) {
  return request({
    url: '/api/mitmgkmp/foundSelfData',
    method: 'post',
    data,
  })
}
